module.exports = __webpack_public_path__ + "media/img/event/speakers/wanping-headshot-2-a32b6a40e7ede4a42e5c4c05267ba74f.png";